<template lang="pug">
.collection-tiles(v-if="schemaData")
  .collection-tiles__wrapper.wrapper
    swiper.collection-tiles__swiper(ref="collectionTiles" :options="swiperOptions")
      swiper-slide.collection-tiles__swiper-slide(
        v-for="(tile, index) in schemaData.tile" :key="index"
        v-if="tile.collectionHandle != schemaData.currentCollection")
        a.collection-tiles__link(
          v-if="tile.collectionUrl && tile.collectionTitle"
          :href="tile.collectionUrl" :aria-label="tile.collectionTitle")
          p.collection-tiles__title(v-html="tile.collectionTitle")
          img.collection-tiles__image(v-if="tile.image" :src="tile.image" :alt="tile.collectionTitle")
    .collection-tiles__navigation-arrow.collection-tiles__navigation-arrow--left
      icon(name="chevron-left" size="20px")
    .collection-tiles__navigation-arrow.collection-tiles__navigation-arrow--right
      icon(name="chevron-right" size="20px")
</template>

<script>
  import 'swiper/swiper.scss';
  import Icon from 'scripts/components/basic/Icon.vue';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: 'CollectionTile',
    components: {
      Icon,
      swiper,
      swiperSlide
    },
    props: {
      schemaData: {
        currentCollection: {
           type: String
        },
        tile: {
          image: {
            type: String
          },
          collectionTitle: {
            type: String
          },
          collectionHandle: {
            type: String
          },
          collectionUrl: {
            type: String
          }
        }
      }
    },
    data() {
      return {
        swiperOptions: {
          loop: false,
          slidesPerView: 4,
          spaceBetween: 25,
          allowTouchMove: false,
          navigation: {
            nextEl: '.collection-tiles__navigation-arrow--right',
            prevEl: '.collection-tiles__navigation-arrow--left',
          },
          breakpoints: {
            1080: {
              slidesPerView: 3
            },
            760: {
              slidesPerView: 2.2,
              spaceBetween: 16,
              allowTouchMove: true,
            }
          },
        },
      };
    }
  };
</script>

<style scoped lang="scss">
  .collection-tiles {
    padding: rem(16px) 0;

    @include tablet-up(){
      padding: rem(60px) 0;
    }
  }
  .collection-tiles__wrapper {
    position: relative;

    @include mobile-only() {
      padding-right: 0;
    }
  }
  .collection-tiles__swiper {}
  .collection-tiles__swiper-slide {}
  .collection-tiles__link,
  .collection-tiles__link:link,
  .collection-tiles__link:visited{
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 15px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color-black, .25);
      z-index: 1;
      transition: opacity .3s ease-in-out;
      opacity: 0;

      @include mobile-only() {
        opacity: 1;
      }
    }

    &:hover,
    &:active {
      * { color: var(--color-navy-500) };
      &:after { opacity: 1 }
    }

    @include tablet-up() {
      border-radius: 30px;
    }
  }
  .collection-tiles__title {
    position: absolute;
    bottom: 4px;
    left: 16px;
    width: 100%;
    font-size: rem(16px);
    font-family: $primary-font-family;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: 0;
    z-index: 2;

    @include tablet-up(){
      bottom: 10px;
      left: 35px;
      font-size: rem(20px);
    }
  }
  .collection-tiles__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  // Navigation
  .collection-tiles__navigation-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1.5px solid var(--color-navy-500);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s;
    z-index: 100;

    .icon {
      color: var(--color-navy-500);
    }

    &:hover {
      background-color: var(--color-navy-500);
      border: 1.5px solid $color-black;

      .icon {
        color: $color-black;
      }
    }
  }
  .collection-tiles__navigation-arrow--left {
    left: 5px;
    @include tablet-up() {
      left: 40px;
    }
  }
  .collection-tiles__navigation-arrow--right {
    right: 15px;
    @include tablet-up() {
      right: 40px;
    }
  }
  .collection-tiles__navigation-arrow--left.swiper-button-disabled,
  .collection-tiles__navigation-arrow--right.swiper-button-disabled {
    display: none;
  }
</style>
